/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 活动兑换奖品创建预订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  goodAdvanceReq: order.GoodAdvanceReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/winning/good-advance`,
    data: goodAdvanceReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
